import * as Yup from 'yup';

export type TFormValues = {
  email: string;
};

export const initialValues: TFormValues = {
  email: '',
};

export const validationSchema = Yup.object().shape({
  email: Yup.string().required('validation.required').email('validation.email'),
});
